var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"delete icon",class:{disabled: _vm.disabled},attrs:{"title":_vm._f("t")('Delete','app'),"role":"button","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }